import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONT_FAMILY, PDF_FONT_SIZE } from '../../../components/reports/shared/constants';
import { getTablePDFStyle } from '../../../components/constants';
import { DateUtil } from '@src/packages/utils/dates';

getTablePDFStyle();

const borderColor = '#e0e0e0';
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 20,
    fontSize: PDF_FONT_SIZE.VALUE,
    fontFamily: PDF_FONT_FAMILY,
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: borderColor,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: '1px',
    borderStyle: 'solid',
    borderColor: borderColor,
    overflow: 'hidden',
  },
  tableColHeader: {
    backgroundColor: borderColor,
    padding: 5,
    fontSize: 8,
    fontWeight: 'bold',
  },
  tableCol: {
    borderWidth: '0px',
    padding: 5,
    fontSize: 7,
  },
  textCell: {
    fontSize: PDF_FONT_SIZE.VALUE,
  },
});

const ActiveEnterprisesPDFTemplate = ({ data, columns, formatIdCard }) => {
  const getColumnWidth = () => `${100 / columns.length}%`;
  const isLastRow = rowIndex => rowIndex === data.length - 1;

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View>
          <Text style={styles.title}>Reporte de Empresas Activas</Text>
        </View>

        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            {columns.map((column, index) => (
              <View key={index} style={[styles.tableColHeader, { width: getColumnWidth() }]}>
                <Text>{column.title || ''}</Text>
              </View>
            ))}
          </View>

          {/* Table Body */}
          {data.map((record, rowIndex) => (
            <View
              key={rowIndex}
              style={[styles.tableRow, isLastRow(rowIndex) && { borderBottomWidth: '0px' }]}
            >
              {columns.map((column, colIndex) => {
                let value = record[column.dataIndex] || '-';

                // Handle special cases
                if (column.dataIndex === 'auditUrl' && record.auditUrl) {
                  value = record.auditUrl;
                }

                if (column.dataIndex.toLowerCase() === 'rut' && record.RUT) {
                  value = formatIdCard(record.RUT);
                }

                if (column.dataIndex === 'contractExpiryDate' && record.contractExpiryDate) {
                  value = DateUtil.toDateString(
                    record.contractExpiryDate,
                    DateUtil.DEFAULT_DT_DATE_FORMAT,
                  );
                }

                return (
                  <View key={colIndex} style={[styles.tableCol, { width: getColumnWidth() }]}>
                    <Text style={styles.textCell}>{value.toString()}</Text>
                  </View>
                );
              })}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default ActiveEnterprisesPDFTemplate;
